import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { Response } from '../models/response';
import { usuario } from '../models/usuario';
import { PermissionService } from './permission.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from 'src/environments/environment';

const httpOption = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': 'true',
    'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class ApiauthService {
  url = environment.baseUrl+ '/api/security/Autenticar';

  jwtHelper = new JwtHelperService();

  private usuarioSubject: BehaviorSubject<usuario>;
  private userLoggedIn = new Subject<boolean>();

  public get usuarioData() {
    return this.usuarioSubject.value;
  }

  constructor(
    private http: HttpClient,
    private PermissionService: PermissionService
  ) {
    this.userLoggedIn.next(false);

    this.usuarioSubject = new BehaviorSubject<usuario>(
      JSON.parse(localStorage.getItem('usuario') || '{}')
    );
  }

  login(email: string, password: string): Observable<usuario> {
    return this.http
      .post<usuario>(this.url, { email, password }, httpOption)
      .pipe(
        map((res) => {
console.log('resssss',res);

          if (res.email !== undefined) {
            res.logueado = true;
            res.photoProfileSmall = res.photoProfileSmall || './assets/images/avatarProfile.jpg';
            localStorage.setItem('usuario', JSON.stringify(res));
            localStorage.setItem('token', res.token);
            this.setUserLoggedIn(true);
            this.usuarioSubject.next(res);
          }
          return res;
        })
      );
  }
  getUser(): usuario {
    return JSON.parse(localStorage.getItem('usuario') || '{}');
  }
  getToken(): string| null {
    return localStorage.getItem('token');
  }

  logout() {
    localStorage.removeItem('usuario');
    this.usuarioSubject.next({
      email: '',
      nombre: '',
      token: '',
      logueado: false,
      photoProfileSmall: '',
      estadoLogin:0
    });
    this.setUserLoggedIn(false);
  }

  setUserLoggedIn(userLoggedIn: boolean) {
    this.userLoggedIn.next(userLoggedIn);
  }

  getUserLoggedIn(): Observable<boolean> {
    return this.userLoggedIn.asObservable();
  }

  //valida si el usuaro esta logueado con un token que no ha expirado
  loggedIn(): boolean {
    const token = localStorage.getItem('token') || '';
    return !this.jwtHelper.isTokenExpired(token);
  }
}
